import React from "react";
declare const I18n;

export function I18nRichText({ tKey, fallbackText }: { tKey?: string; fallbackText?: string }) {
  let text = tKey ? I18n.t(tKey) : fallbackText || "";

  text = text.replace(/<accent>(.*?)<\/accent>/g, `<span class="i18n-accent">$1</span>`);

  return <span dangerouslySetInnerHTML={{ __html: text }} />;
}
